export const LISTEN_TO_CURRENT_USER_PROFILE = 'LISTEN_TO_CURRENT_USER_PROFILE';
export const BINDING_ACCOUNT = 'BINDING_ACCOUNT';
export const LISTEN_FOR_DSZ_BELOW_PRICE = 'LISTEN_FOR_DSZ_BELOW_PRICE';
export const CLEAR_DSZ_PRICE_NOTIFICATION = 'CLEAR_DSZ_PRICE_NOTIFICATION';